import React from 'react';
import { Spinner } from '@/components/ui/spinner';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useGoalFormContext } from './goalFormState';
import { ObjectiveFormData } from './types';

type Props = {
  disabled?: boolean;
};

export const GoalSaveButton: React.FC<React.PropsWithChildren<Props>> = ({
  disabled,
}) => {
  const { t } = useTranslation();
  const { isSubmitting } = useGoalFormContext<ObjectiveFormData>();
  const isDisabled = disabled || isSubmitting;

  return (
    <Button type="submit" className="w-100" disabled={isDisabled}>
      {isSubmitting && (
        <Spinner size="sm" animation="border" className="me-2" />
      )}
      {t('form.general.saveButton')}
    </Button>
  );
};
